import type { ManualEntryValidationResult } from './manualEntryTypes';

interface ValidationPanelProps {
  validation: ManualEntryValidationResult | null;
}

export function ValidationPanel({ validation }: ValidationPanelProps) {
  if (!validation) return null;

  return (
    <div style={{ flex: 1 }}>
      {validation.is_valid ? (
        <div style={{
          padding: '12px',
          borderRadius: '6px',
          backgroundColor: '#d1fae5',
          border: '1px solid #6ee7b7',
          marginBottom: '8px'
        }}>
          <div style={{ fontWeight: '500', marginBottom: '4px', color: '#065f46' }}>
            ✓ Validation Passed
          </div>
          <div style={{ fontSize: '14px', color: '#047857' }}>
            Content is valid and ready to save.
          </div>
        </div>
      ) : (
        <div style={{
          padding: '12px',
          borderRadius: '6px',
          backgroundColor: '#fee2e2',
          border: '1px solid #fca5a5',
          marginBottom: '8px'
        }}>
          <div style={{ fontWeight: '500', marginBottom: '4px', color: '#991b1b' }}>
            ✗ Validation Failed
          </div>
          <div style={{ fontSize: '14px', color: '#dc2626' }}>
            {validation.errors?.map((error: string, index: number) => (
              <div key={index}>• {error}</div>
            ))}
          </div>
        </div>
      )}

      {validation.warnings && validation.warnings.length > 0 && (
        <div style={{
          padding: '12px',
          borderRadius: '6px',
          backgroundColor: '#fef3c7',
          border: '1px solid #fcd34d',
          marginBottom: '8px'
        }}>
          <div style={{ fontWeight: '500', marginBottom: '4px', color: '#92400e' }}>
            ⚠ Warnings
          </div>
          <div style={{ fontSize: '14px', color: '#b45309' }}>
            {validation.warnings.map((warning: string, index: number) => (
              <div key={index}>• {warning}</div>
            ))}
          </div>
        </div>
      )}

      {validation.existing_manual_entries > 0 && (
        <div style={{
          padding: '12px',
          borderRadius: '6px',
          backgroundColor: '#e0e7ff',
          border: '1px solid #a5b4fc'
        }}>
          <div style={{ fontSize: '14px', color: '#4338ca' }}>
            ℹ This program has {validation.existing_manual_entries} recent manual {validation.existing_manual_entries === 1 ? 'entry' : 'entries'}.
          </div>
        </div>
      )}
    </div>
  );
}
